import React from 'react';
import { Code2, Languages, Lightbulb, Palette } from 'lucide-react';
import { features } from '../data/mock';

const iconMap = {
  Code2: Code2,
  Languages: Languages,
  Lightbulb: Lightbulb,
  Palette: Palette
};

const Features = () => {
  return (
    <section id="features" className="py-24 bg-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-orange-500 via-amber-500 to-yellow-500"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            Nieograniczone możliwości{' '}
            <span className="bg-gradient-to-r from-orange-600 to-amber-600 bg-clip-text text-transparent">
              edukacyjne
            </span>
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Zosia łączy w sobie nowoczesne technologie z metodami pedagogicznymi,
            wspierając rozwój dzieci w kluczowych obszarach
          </p>
        </div>

        {/* Features grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {features.map((feature, index) => {
            const Icon = iconMap[feature.icon];
            const isEven = index % 2 === 0;

            return (
              <div
                key={feature.id}
                className="group relative bg-gradient-to-br from-slate-50 to-white rounded-3xl overflow-hidden hover:shadow-2xl transition-all duration-500 border border-slate-100"
              >
                {/* Image section */}
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={feature.image}
                    alt={feature.title}
                    className="w-full h-full object-cover transform group-hover:scale-110 transition-transform duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                  
                  {/* Icon badge */}
                  <div className="absolute top-6 left-6 w-14 h-14 bg-white/90 backdrop-blur-sm rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                    <Icon className="w-7 h-7 text-orange-500" />
                  </div>
                </div>

                {/* Content section */}
                <div className="p-8">
                  <h3 className="text-2xl font-bold text-slate-900 mb-3 group-hover:text-orange-600 transition-colors">
                    {feature.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed">
                    {feature.description}
                  </p>
                </div>

                {/* Decorative element */}
                <div className={`absolute bottom-0 ${isEven ? 'right-0' : 'left-0'} w-32 h-32 bg-gradient-to-br from-orange-500/10 to-amber-500/10 rounded-full transform translate-y-16 ${isEven ? 'translate-x-16' : '-translate-x-16'} group-hover:scale-150 transition-transform duration-700`}></div>
              </div>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center space-x-2 px-6 py-3 bg-gradient-to-r from-orange-50 to-amber-50 rounded-full border border-orange-200">
            <span className="text-orange-700 font-medium">
              ✨ Wszystkie funkcje w jednym urządzeniu
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
